export default {
  priceToNumber (val) {
    val = String(val).replace('₺', '')
      .replace(/ /gi, '')
      .replace(/,/g, '.');

    return parseFloat(val);
  },
  price (value) {
    if (!value) {
      return '-';
    }

    const price = String(parseFloat(value).toFixed(2)).split('.');
    const priceValue = price[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    const decimals = price[1] || '00';
    return `${priceValue},${decimals} ₺`;
  },
  quantity (value) {
    const quantity = String(parseInt(value));
    return quantity.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  },
  stripTags (text) {
    const el = document.createElement('div');
    el.innerHTML = text;
    return String(el.innerText).trim();
  },
  formatTime (time) {
    const seconds = time % 60;
    const minutes = Math.trunc(time / 60) % 60;
    const hours = Math.trunc(time / 60 / 60) % 24;

    return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  },
};
